import { useTranslation } from "react-i18next";

const defaultRender = (value) => (value ? value : "0.00");
const useTransactionCell = () => {
    const { t } = useTranslation();

    const formatAmount = (value) => {
        if (isNaN(value)) return "0.00";
        return Number(value).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    };
    return [
        { title: t("time"), dataIndex: 'dateTime', render: defaultRender, },
        { title: t("id"), dataIndex: 'ticket', render: defaultRender, },
        { title: t('amount'), dataIndex: 'amount', render: (value) => formatAmount(value), },
        {
            title: t('transactionType'), dataIndex: 'type', render: (value) => {
                const typeMap = {
                    1: "Deposit",
                    2: "Adjustment",
                    3: "Credit In",
                    4: "Withdrawal",
                    5: "Credit Out",
                };
                return typeMap[value] || "Unknown";
            },
        },
    ];
};

export default useTransactionCell;
